export default __webpack_public_path__ + "static/media/Kaihousuu.e7ab8c80.svg";